export const clone = obj => JSON.parse(JSON.stringify(obj));